import { Table } from 'react-bootstrap';
import AccordionCard from '../AccordionCard';

const CompSerialNumFormatOld = () => {
  return (
    <>
      <AccordionCard title="Format Table" parent="compSerialNumAccordion">
        <Table className="m-0" striped responsive>
          <thead className="fs-4">
            <tr>
              <th>Position</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Position 1</td>
              <td>Always “P” indicating Property Record</td>
            </tr>
            <tr>
              <td>Positions 2- 27</td>
              <td>Tax Year (trailing spaces)</td>
            </tr>
            <tr>
              <td>Positions 28 - 36</td>
              <td>Property Serial Number</td>
            </tr>
            <tr>
              <td>Example</td>
              <td>
                P2010 010010001 <br />
                P2010 010010003
              </td>
            </tr>
          </tbody>
        </Table>
      </AccordionCard>
    </>
  );
};

export default CompSerialNumFormatOld;
